<div class="web-links-container">
  <div class="web-links-header">
    <strong>Связанные задачи</strong>
    <nb-icon icon="plus-circle-outline" (click)="openForm()"></nb-icon>
  </div>

  <app-issue-subtask-list [items]="store.items$" [store]="store" [issue]="issue"></app-issue-subtask-list>

  <div *ngIf="showForm">
    <div *ngIf="tasks.length">
      <p *ngFor="let task of tasks">

        <nb-icon [icon]="task.icon" pack="jira"></nb-icon>
        {{ task.issueId }} {{ task.header }}

        <button nbButton nbTooltip="Удалить" size="tiny" (click)="remove(task)">
          <nb-icon icon="trash-outline"></nb-icon>
        </button>
      </p>
      <p>
        <button nbButton size="small" (click)="removeAll()">
          <nb-icon icon="trash-outline"></nb-icon>
          Удалить все
        </button>
      </p>
    </div>

    <p>
      <input nbInput fullWidth fieldSize="small" type="text" [matAutocomplete]="auto" [formControl]="control"/>
    </p>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let task of searchStore.items$ | async" [value]="task" class="mat-option-flex">
        <nb-icon [icon]="task.icon" pack="jira"></nb-icon>
        {{ task.issueId }} {{ task.header }}
      </mat-option>
    </mat-autocomplete>

    <div class="web-link-buttons">
      <button nbButton size="small" status="primary" [disabled]="!tasks.length" (click)="onSubmit()">Связать</button>
      <button nbButton size="small" status="basic" type="button" (click)="closeForm()">Отмена</button>
    </div>
  </div>
</div>
